import {
  FinanceCostCenterMembershipsDocument,
  FinanceCostCenterMembershipsQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export type CostCenterMembership =
  FinanceCostCenterMembershipsQuery['finance']['costCenterMembershipsConnection']['nodes'][number]

export const useCostCenterMemberships = (activeOn: Date, employeeId?: number) => {
  const { company } = useCurrentSession()

  const { loading, data } = useQuery(FinanceCostCenterMembershipsDocument, {
    variables: {
      employeeId: employeeId,
      companyId: company.id,
      activeOn: activeOn.toISOString(),
    },
    skip: !employeeId,
  })

  const costCenterMemberships = (data?.finance?.costCenterMembershipsConnection?.nodes || []).map(
    (membership) =>
      ({
        id: membership.id,
        costCenter: membership.costCenter,
        percentage: membership.percentage * 100,
      } as CostCenterMembership)
  )

  return {
    memberships: costCenterMemberships,
    loading: loading,
  }
}
